import $axios from '@/core/api-config'

class ProfileService {
  profile () {
    return $axios.get('/api/profile')
  }

  update (data) {
    return $axios.post('/api/profile', data)
  }

  delete (isRestore) {
    return $axios.delete('/api/profile', { data: { isRestore: isRestore } })
  }

  restore (user) {
    return $axios.post('/api/profile/restore', { email: user.email, password: user.password })
  }
}

export const profileService = new ProfileService()
